export default __webpack_public_path__ + "static/media/down_pdf.edcdfc76.svg";